export class MultiMessageConfig {
  active: boolean;
  hourToRun: string; // string representation of an hour of the day
  timeBefore: number; // valid number is 1 to 90
}
